import React, { useState, useRef, useEffect } from 'react';
import fetchAPI from '../../../common/fetchAPI';
import { useLocation } from 'react-router-dom';
import { ShowToast } from '../../../common/Toastr';
import Select, { StylesConfig } from 'react-select';
import { formatDateWithDateAndMonthName, formatNumberCustomoriginalapiv2, parseLocalizedNumber, validateCultureNumber, formatNumberCustomoriginal, getPageSizeArray, setItemStatus, headerDropDownStyles, paginationStyles, getValueFromResource, FormatInvoiceDecimalNumber, determineCommaSeprater } from '../../../common/timeLiveFunction';
import { getAccountWorkTypeByAccountWorkTypeIdAsync } from '../../admin/worktype/worktypeSlice';
import CustomPagination from "../../../common/Pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useDebounce } from '../../../_metronic/helpers';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { Dropdown } from 'react-bootstrap'
import ProjectTeamAllocationHours from "./ProjectTeamAllocationHours";
import { useTranslation } from "react-i18next";
import { updatePageSizeTeam } from '../../../common/GlobalSlice';
import {
    getDataByAllocationHours
} from "../projectSlice";
const initialValues = {
    isTeamSelected: true,
    isRelod: false,
    isLoading: true,
    accountWorkTypeId: 0
}

const objDropdown = {
    currenciesResponse: [],
    workTypeResponse: [],
    accountEmployeeResponse: [],
    accountRoleResponse: []
}

const initialPaginationValues = {
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isPagination: false,
    sortOrder: 'asc',
    sortColumn: "1"
}




const ProjectTeam = (props: any) => {
    const [selectedEmployeeName, setSelectedEmployeeName] = useState(null);
    const [selectedDepartmentName, setSelectedDepartmentName] = useState(null);
    const [selectedProjectName, setSelectedProjectName] = useState(null);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [selectedProjectEmployeeId, setSelectedProjectEmployeeId] = useState(null);
    const { onopenModal } = props;
    const dispatch = useAppDispatch();
    const { state } = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { AccountProjectId, ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId,IsTask,IsMilestone,IsProjectTeam
        //, IsEditProjectTeam 
    } = state.obj;
    const [projectTeam, setProjectTeam] = useState<any | ''>([]);
    const [teamResponse, setTeamResponse] = useState<any | ''>(initialValues);
    const [pagination, setPagination] = useState<any | ''>(initialPaginationValues);
    const [dropdownResponse, setDropdownResponse] = useState<any | ''>(objDropdown);
    const { CurrentCultureDateFormat, cultureInfoName, decimalPlaces, accountIdsForAllocationHours, accountBaseCurrencyId, maxMenuHeight, allocationHoursInProjectTeam, calendarStartDay,pageSizeTeam } = useAppSelector((state) => state.globalState)
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const modelRef = useRef<any>(null);

    useEffect(() => {
        if (pagination.isPagination == false) {
            ProjectBillingRateTypeId == 2 && renderProjectRolesAndCurrentActiveEmployee();
            (ProjectBillingRateTypeId == 1 || ProjectBillingRateTypeId == 3 || ProjectBillingRateTypeId == 4) && renderWorkTypeAndCurrencies()
            // setTeamResponse({
            //     ...teamResponse,
            //     isLoading: false
            // });
        } else {
            renderProjectTeam(teamResponse.isTeamSelected);
            setIsFirstTimeLoad(false);
        }
    }, [pagination.isPagination, pagination.pageNo, pagination.pageSize, pagination.sortColumn, pagination.sortOrder]);


    const debouncedSearchTerm = useDebounce(pagination.search, 500);
    useEffect(() => {
        if (!isFirstTimeLoad) {
            if (pagination.isPagination == false) {
                ProjectBillingRateTypeId == 2 && renderProjectRolesAndCurrentActiveEmployee();
                (ProjectBillingRateTypeId == 1 || ProjectBillingRateTypeId == 3 || ProjectBillingRateTypeId == 4) && renderWorkTypeAndCurrencies()
            } else {
                renderProjectTeam(teamResponse.isTeamSelected);
                setIsFirstTimeLoad(false);
            }
        }
    }, [debouncedSearchTerm]);

    const renderWorkTypeAndCurrencies = async () => {
        try {
            const response = await fetchAPI(`api/V2/Projects/GetAllDataInSingleRequestForCurrencyAndWorkType/`, 'Get', '', true);
            const json = await response.json();
            json["AccountWorkType"].map((item: any) => {
                item.value = item.AccountWorkTypeId;
                item.label = item.AccountWorkType;
                delete item.AccountWorkTypeId;
                delete item.AccountWorkType;
            });
            json["AccountCurrency"].map((item: any) => {
                item.value = item.AccountCurrencyId;
                item.label = item.CurrencyCode;
                delete item.AccountCurrencyId;
                delete item.CurrencyCode;
            });
            setTeamResponse({
                ...teamResponse,
                accountWorkTypeId: json["AccountWorkType"][0].value
            })
            setDropdownResponse({
                ...dropdownResponse,
                workTypeResponse: json["AccountWorkType"],
                currenciesResponse: json["AccountCurrency"]
            });
            renderProjectTeam(true, json["AccountWorkType"][0].value);
        } catch (error) {
            setTeamResponse({
                ...teamResponse,
                isLoading: false
            });
        }
    }

    const renderProjectRolesAndCurrentActiveEmployee = async () => {
        try {
            const response = await fetchAPI(`api/V2/Projects/GetAllDataInSingleRequestForProjectRolesAndCurrentActiveEmployee/${AccountProjectId}`, 'Get', '', true);
            const json = await response.json();
            json["AccountEmployee"].map((item: any) => {
                item.value = item.AccountEmployeeId;
                item.label = item.FirstName + item.LastName;
                delete item.AccountEmployeeId;
                delete item.FirstName;
                delete item.LastName;
            });
            json["AccountRole"].map((item: any) => {
                item.value = item.AccountRoleId;
                item.label = item.Role;
                delete item.AccountRoleId;
                delete item.Role;
            });
            setDropdownResponse({
                ...dropdownResponse,
                accountEmployeeResponse: json["AccountEmployee"],
                accountRoleResponse: json["AccountRole"]
            });
            renderProjectTeam(true, json["AccountWorkType"][0].AccountWorkTypeId);
        } catch (error) {
            setTeamResponse({
                ...teamResponse,
                isLoading: false
            });
        }
    }

    const renderProjectTeam = async (selected: boolean = true, workTypeId: Number = teamResponse.accountWorkTypeId, fromUpdate: boolean = false) => {
        try {
            const { startRec, pageSize, pageNo, search, sortColumn, sortOrder } = pagination;
            let id = (workTypeId != teamResponse.accountWorkTypeId ? workTypeId : teamResponse.accountWorkTypeId)
            const response = await fetchAPI(`api/V2/Projects/GetAccountProjectEmployeesDatatable/${AccountProjectId}/${id}/${selected}//${sortColumn}/${sortOrder}/${startRec}/${pageSizeTeam}/${pageNo}/${search}`, 'Get', '', true);
            const json = await response.json();
            let teamArray = ProjectBillingRateTypeId === 2 ? json : JSON.parse(json.data);
                      const formattedBillingRate = formatNumberCustomoriginalapiv2(
            cultureInfoName.toString(), 
            0, 
            decimalPlaces
          );
            const formattedEmployeeRate = formatNumberCustomoriginalapiv2(
            cultureInfoName.toString(), 
            0, 
            decimalPlaces
          );
            teamArray.map((item: any, index: any) => {
                item.isSelected = (item.AccountProjectEmployeeId == null || item.AccountProjectEmployeeId <= 0) ? 0 : 1;
                item.AllocationHours = item.AllocationHours != null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),item.AllocationHours,2) : FormatInvoiceDecimalNumber(cultureInfoName.toString(),0,2);
                item.StartDate = item.StartDate != null ? new Date(item.StartDate) : new Date();
                item.EndDate = item.EndDate != null ? new Date(item.EndDate) : new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                //item.BillingRate = item.accountBillingRateId != 0 ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), item.BillingRate, decimalPlaces) : formattedBillingRate;
                //item.EmployeeRate = item.accountBillingRateId != 0 ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), item.EmployeeRate, decimalPlaces) : formattedEmployeeRate;
                    if (item.BillingRate == null || item.BillingRate === 0 || item.accountBillingRateId === 0) {
                        

        item.BillingRate = ''//formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces);
    } else {
        item.BillingRate = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), item.BillingRate, decimalPlaces);
    }
    
    // Format EmployeeRate - ensure it's always a formatted string
    if (item.EmployeeRate == null || item.EmployeeRate === 0 || item.accountBillingRateId === 0) {
        item.EmployeeRate = ''//formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces);
    } else {
        item.EmployeeRate = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), item.EmployeeRate, decimalPlaces);
    }
            });
            setProjectTeam(teamArray);
            setPagination({
                ...pagination,
                startRec: json.start,
                //pageSize: json.value,
                pageNo: json.currentPage,
                search: json.searchText,
                totalItems: json.recordsTotal,
                recordsFiltered: json.recordsFiltered,
                isPagination: true
            });
            setTeamResponse({
                ...teamResponse,
                accountWorkTypeId: id,
                isTeamSelected: selected ? true : false,
                isLoading: false
            });
        } catch (error) {
            setTeamResponse({
                ...teamResponse,
                isLoading: false
            });
        }
    }

    const onUpdateTeamInProject = async () => {
        try {
            setTeamResponse({
                ...teamResponse,
                isLoading: true
            });
            let finalArray: any[] = [];
            projectTeam.map((item: any) => {
                if (teamResponse.isTeamSelected == false && item.isSelected) {
                    if (ProjectBillingRateTypeId === 1 || ProjectBillingRateTypeId === 4) {
                        finalArray.push({
                            AccountEmployeeId: item.AccountEmployeeId,
                            AccountProjectEmployeeId: "",
                            AccountRoleId: item.AccountRoleId != null ? item.AccountRoleId : 0,
                            AllocationHours: item.AllocationHours != null ?  parseLocalizedNumber(item.AllocationHours) : 0.00,
                            IsSelected: true
                        })
                    } else if (ProjectBillingRateTypeId === 3) {
                        finalArray.push({
                            AccountEmployeeId: item.AccountEmployeeId,
                            AccountProjectEmployeeId: "",
                            AccountRoleId: item.AccountRoleId != null ? item.AccountRoleId : 0,
                            AllocationHours: item.AllocationHours != null ? parseLocalizedNumber(item.AllocationHours) : 0.00,
                            BillingRateCurrencyId: item.BillingRateCurrencyId != null ? item.BillingRateCurrencyId : accountBaseCurrencyId,
                            BillingRate: item.BillingRate != null ? parseLocalizedNumber(item.BillingRate) : 0.00,
                            EmployeeRateCurrencyId: item.EmployeeRateCurrencyId != null ? item.EmployeeRateCurrencyId : accountBaseCurrencyId,
                            EmployeeRate: item.EmployeeRate != null ? parseLocalizedNumber(item.EmployeeRate) : 0.00,
                            StartDate: item.StartDate != null ? moment(item.StartDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
                            EndDate: item.EndDate != null ? moment(item.EndDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
                            IsSelected: true
                        })
                    } else if (ProjectBillingRateTypeId === 2) {
                        finalArray.push({
                            AccountEmployeeId: item.AccountEmployeeId,
                            AccountProjectEmployeeId: item.AccountProjectEmployeeId > 0 ? item.AccountProjectEmployeeId : '',
                            AccountRoleId: item.AccountRoleId,
                            AllocationHours: item.AllocationHours != null ? parseLocalizedNumber(item.AllocationHours) : 0.00,
                            IsSelected: true
                        })
                    }
                }
                else if (teamResponse.isTeamSelected && (ProjectBillingRateTypeId === 1 || ProjectBillingRateTypeId === 4)) {
                    // && !item.isSelected
                    finalArray.push({
                        AccountEmployeeId: item.AccountEmployeeId,
                        AccountProjectEmployeeId: item.AccountProjectEmployeeId,
                        AccountRoleId: item.AccountRoleId != null ? item.AccountRoleId : 0,
                        AllocationHours: item.AllocationHours != null ? parseLocalizedNumber(item.AllocationHours) : 0.00,
                        //IsSelected: false
                        IsSelected: item.isSelected === 1 ? true : false
                    })
                }
                else if (teamResponse.isTeamSelected && ProjectBillingRateTypeId === 2) {
                                    // Normalize numeric values before creating object
                    const normalizedEmployeeRate = parseLocalizedNumber(item.EmployeeRate);
                    const normalizedBillingRate = parseLocalizedNumber(item.BillingRate);
                    //&& item.AccountProjectEmployeeId <= 0
                    finalArray.push({
                        AccountEmployeeId: item.AccountEmployeeId,
                        AccountProjectEmployeeId: item.AccountProjectEmployeeId,
                        AccountRoleId: item.AccountRoleId != null ? item.AccountRoleId : 0,
                        AllocationHours: item.AllocationHours != null ? parseLocalizedNumber(item.AllocationHours) : 0.00,
                        EmployeeRate: item.EmployeeRate != null ? normalizedEmployeeRate : 0.00,
                        BillingRate: item.BillingRate != null ? normalizedBillingRate : 0.00,
                        //IsSelected: true
                        IsSelected: item.isSelected === 1 ? true : false
                    })
                }
                else if (teamResponse.isTeamSelected && ProjectBillingRateTypeId === 3) {
                                    // Normalize numeric values before creating object
                    const normalizedEmployeeRate = parseLocalizedNumber(item.EmployeeRate);
                    const normalizedBillingRate = parseLocalizedNumber(item.BillingRate);
                    finalArray.push({
                        AccountEmployeeId: item.AccountEmployeeId,
                        AccountProjectEmployeeId: item.AccountProjectEmployeeId,
                        AccountRoleId: item.AccountRoleId,
                        AllocationHours: parseLocalizedNumber(item.AllocationHours),
                        // BillingRateCurrencyId: item.BillingRateCurrencyId,
                        BillingRateCurrencyId: item.BillingRateCurrencyId != null ? item.BillingRateCurrencyId : accountBaseCurrencyId,
                        // BillingRate: item.BillingRate,
                        BillingRate: item.BillingRate != null ? normalizedBillingRate : '',
                        // EmployeeRateCurrencyId: item.EmployeeRateCurrencyId,
                        EmployeeRateCurrencyId: item.EmployeeRateCurrencyId != null ? item.EmployeeRateCurrencyId : accountBaseCurrencyId,
                        // EmployeeRate: item.EmployeeRate,
                        EmployeeRate: item.EmployeeRate != null ? normalizedEmployeeRate : '',
                        StartDate: moment(item.StartDate).format('YYYY-MM-DD'),
                        EndDate: moment(item.EndDate).format('YYYY-MM-DD'),
                        // IsSelected: true,
                        IsSelected: item.isSelected === 1 ? true : false,
                        AccountBillingRateId: '0'
                    })
                }
            })
            const response = await fetchAPI(`api/V2/Projects/Employee?AccountProjectId=${AccountProjectId}&AccountWorkTypeId=${teamResponse.accountWorkTypeId}&IsSelected=${teamResponse.isTeamSelected}`, 'POST', finalArray, true);
            const json = await response.json();
            if (Number(json.Id) > 0) {
                setTimeout(() => {
                    renderProjectTeam(true, teamResponse.accountWorkTypeId, true).then((result) => {
                        if (ProjectBillingRateTypeId === 2) {
                            navigateToProjectSummary({
                                "AccountProjectId": AccountProjectId,
                                "ProjectCode": ProjectCode,
                                "ProjectName": ProjectName,
                                "Status": Status,
                                "StartDate": StartDate,
                                "Deadline": Deadline,
                                "ProjectBillingRateTypeId": 2,
                                "IsSummaryFrom": 'View',
                                "IsTask": IsTask,
                                "IsMilestone": IsMilestone,
                                "IsProjectTeam": IsProjectTeam
                            });
                        } 
                        json.StatusCode == '200' ? ShowToast('Success', json.ResponseMessage, "success", "toast-top-right") :
                            ShowToast('Error', "Record(s) Updated Failed!", "error", "toast-top-right");
                    });
                }, 1000)
            }
        } catch (error) {
            setTeamResponse({
                ...teamResponse,
                isLoading: false
            });
        }
    }

    const navigateToProjectSummary = (obj: any) => {
        localStorage.setItem('objProject', JSON.stringify(obj));
        navigate(`/accountprojectsummary/${obj.AccountProjectId}`);
    }

    const onAddTeamInProject = () => {
        if (ProjectBillingRateTypeId === 2) {
            navigate('/accountprojectrole', {
                state: {
                    "AccountProjectId": AccountProjectId,
                    "ProjectCode": ProjectCode,
                    "ProjectName": ProjectName,
                    "AccountWorkTypeId": 0,
                    "Status": Status,
                    "StartDate": StartDate,
                    "Deadline": Deadline
                }
            });
        } else {
            setProjectTeam([]);
            setTeamResponse({
                ...teamResponse,
                isLoading: true
            });
            renderProjectTeam(false);
        }
    }

    const onCancelTeamInProject = () => {
        setProjectTeam([]);
        setTeamResponse({
            ...teamResponse,
            isLoading: true
        });
        renderProjectTeam(true);
    }

    const onSelectTeamInProject = (e: any, accountEmployeeId: number) => {
        const index = projectTeam.findIndex((item: any) => item.AccountEmployeeId === accountEmployeeId);
        const newArray = [...projectTeam];
        newArray[index].isSelected = e.target.checked ? 1 : 0;
        setProjectTeam(newArray);
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        const newArray = projectTeam.map((item: any) => ({
            ...item,
            isSelected: checked ? 1 : 0
        }));
        setProjectTeam(newArray);
    }

    const onHandleSearch = (event: any) => {
        setPagination({
            ...pagination,
            isSearch: pagination.isSearch ? false : true,
            search: event.target.value,
            isPagination: true
        });
    }

    // const onHandlePageSizeChange = (selectedOption: any) => {
    //     console.log('renderProjectTeam',selectedOption.value)
    //     setPagination({
    //         ...pagination,
    //         startRec: 0,
    //         pageSize: selectedOption.value,
    //         pageNo: 1,
    //         search: pagination.search,
    //         isPagination: true
    //     });
    // }

    const onHandlePageSizeChange = (selectedOption: any) => {
    dispatch(updatePageSizeTeam(selectedOption.value));
    setPagination((prev : any) => ({
        ...prev,
        startRec: 0,
        pageSize: selectedOption.value,
        pageNo: 1,
        search: pagination.search,
        isPagination: true
    }));
}

    const onHandlePageChange = (pageNumber: any) => {
        setPagination({
            ...pagination,
            startRec: (pageNumber - 1) * Number(pagination.pageSize),
            pageSize: pagination.pageSize,
            pageNo: pageNumber,
            search: pagination.search,
            isPagination: true
        });
    }

    const onHandleCalculation = (data: any, id: number) => {

        const value = data.target.value;
        const name = data.target.name;

        const isComma =  determineCommaSeprater(cultureInfoName.toString());
        console.log('isComma',isComma)

        const hoursRegex = isComma ? /^[0-9]*([,][0-9]{0,2})?$/ : /^[0-9]*([.][0-9]{0,2})?$/;
        const rateRegex = isComma  ? /^[0-9]*([,][0-9]*)?$/ : /^[0-9]*([.][0-9]*)?$/;

        if ((name === 'AllocationHours' && !hoursRegex.test(value)) || ((name === 'BillingRate' || name === 'EmployeeRate') &&
            !rateRegex.test(value))) {
            return;
        }

        const index = projectTeam.findIndex((item: any) => item.AccountEmployeeId === id);

        const newArray = [...projectTeam];

        name === 'AllocationHours' && (newArray[index].AllocationHours = value);
        name === 'BillingRate' && (newArray[index].BillingRate = value);
        name === 'EmployeeRate' && (newArray[index].EmployeeRate = value);
        setProjectTeam(newArray);
    };




    

    const onChange = (data: any, filterName: any, accountEmployeeId: number) => {
        if (filterName.name == "billingCurrency") {
            const index = projectTeam.findIndex((item: any) => item.AccountEmployeeId === accountEmployeeId);
            const newArray = [...projectTeam];
            newArray[index].BillingRateCurrencyId = data.value;
            setProjectTeam(newArray);
        } else if (filterName.name == "employeeRateCurrency") {
            const index = projectTeam.findIndex((item: any) => item.AccountEmployeeId === accountEmployeeId);
            const newArray = [...projectTeam];
            newArray[index].EmployeeRateCurrencyId = data.value;
            setProjectTeam(newArray);
        } else {
            if (projectTeam.filter((x: any) => x.AccountEmployeeId === data.value).length > 0) {
                ShowToast('Warning', "This employee is already assigned in other role!", "warning", "toast-top-right");
            } else {
                const index = projectTeam.findIndex((item: any) => item.AccountProjectEmployeeId === accountEmployeeId);
                const newArray = [...projectTeam];
                newArray[index].AccountEmployeeId = data.value;
                setProjectTeam(newArray);
            }
        }
    }

    const onDateChange = (date: any, name: any, accountEmployeeId: number) => {
        const index = projectTeam.findIndex((item: any) => item.AccountEmployeeId === accountEmployeeId);
        const newArray = [...projectTeam];
        name == "StartDate" ? (newArray[index].StartDate = date) : (newArray[index].EndDate = date);
        setProjectTeam(newArray);
    }

    const onChangeWorkType = (data: any) => {
        renderProjectTeam(true, data.value);
    }

    const editAccountEmployeeById = (AccountWorkTypeId: number) => {
        dispatch(getAccountWorkTypeByAccountWorkTypeIdAsync(AccountWorkTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
                //console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


  const onHandleSorting = (sortOrder: string, sortColumn: string) => {     
        setPagination({
            ...pagination,
            'sortOrder': sortOrder,
            'sortColumn': sortColumn,
            'pageSize': pageSizeTeam,
            'isPagination': true            
        });
          

    }
    return (
        <>
            {teamResponse.isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white dropdown-zindex">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Project Employee List')} */}
                        {getValueFromResource('Project Employee List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {ProjectBillingRateTypeId != 2 &&
                            <>
                                {ProjectBillingRateTypeId == 3 &&
                                    <>
                                        <div className="d-flex align-items-center">
                                            <Select
                                                value={dropdownResponse.workTypeResponse.filter((x: any) => x.value === teamResponse.accountWorkTypeId)}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                name="accountWorkType"
                                                onChange={(e) => onChangeWorkType(e)}
                                                options={dropdownResponse.workTypeResponse}
                                                styles={headerDropDownStyles}
                                            />
                                        </div>
                                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    </>
                                }
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={pagination.search}
                                        onChange={onHandleSearch}
                                        placeholder=
                                        // {t('Search')}
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                    {/* <Select
                                        styles={paginationStyles}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == pagination.pageSize)}
                                        onChange={onHandlePageSizeChange}
                                        className='fs-7 fw-normal'
                                    /> */}
                                 <PageSizeSelect onChange={onHandlePageSizeChange} />

                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(projectTeam.length > 0) ? (
                                        <CustomPagination
                                            currentPage={pagination.pageNo}
                                            onPageChange={onHandlePageChange}
                                            pageSize={pageSizeTeam}
                                            totalItems={pagination.totalItems}
                                            start={pagination.startRec}
                                            t={t}
                                            recordsFiltered={pagination.recordsFiltered}
                                        >
                                        </CustomPagination>
                                    ) : null}
                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            </>
                        }
                        {teamResponse.isTeamSelected ?
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => { onAddTeamInProject() }}
                                style={{ marginRight: 6 }}
                            >
                                <i className="bi bi-person-plus fs-5 me-1"></i>
                                {/* {t('Add Employees In Project')} */}
                                {getValueFromResource('Add Employees In Project',dispatch, t)}
                            </button>
                            : <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => { onCancelTeamInProject() }}
                                style={{ marginRight: 6 }}
                            >
                                {/* {t('Cancel')} */}
                                {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                        }
                        {/* {IsEditProjectTeam && */}
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => { onUpdateTeamInProject() }}
                        >
                            <i className="bi bi-pencil-square fs-5 me-1"></i>
                            {/* {t('Update Records')} */}
                            {getValueFromResource('Update Records',dispatch, t)}
                        </button>
                        {/* } */}
                    </div>
                </div>
                <div className='mt-3'>
                    {/* <div className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0">
                        <a className="text-gray-400">{t("Project Code")}</a>
                        <span className="breadcrumb-item"><span className="bullet bg-gray-400 w-5px h-2px"></span></span>
                        <span className="breadcrumb-item text-muted me-2 fs-6">{ProjectCode}</span>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(Status))} style={{ lineHeight: 0.8 }}>
                            {Status}
                        </span>
                    </div> */}
                    <div className="d-flex align-items-center mt-2 mb-2">
                        <a className="text-muted fw-bold me-2 fs-2">{ProjectName}</a>
                    </div>
                    <div className="d-flex flex-wrap fs-7 mb-4 pe-2">
                        <a className="text-gray-500">
                            <i className="bi bi-calendar fs-6 iconColor me-2"></i>
                            {formatDateWithDateAndMonthName(StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(Deadline, cultureInfoName.toString())}
                            {/* {`${moment(StartDate).format('DD MMM yy')} - ${moment(Deadline).format('DD MMM yy')}`} */}
                            </a>
                        <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(Status))} style={{ lineHeight: 0.8, marginLeft: 4 }}>
                            {Status}
                        </span>
                    </div>
                </div>
                <div className='card-body py-3 mt-2'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            {(ProjectBillingRateTypeId === 1 || ProjectBillingRateTypeId === 4) &&
                                <>
                                    <thead>
                                        <tr className='thHeading align-middle'>
                                            <th className='w-25px'>{t("")}</th>
                                             <th style={{ width: '20%' }}
                                                                    >
                                                                        {getValueFromResource('Employee Name',dispatch, t)}
                                                                        {pagination.sortColumn === '1' ?
                                                                            pagination.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                            </span>
                                                                            :
                                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                        <span className="path1"></span>
                                                                                        <span className="path2"></span>
                                                                                    </i>
                                                                                </span>
                                                                            </>}                                                                            
                                                                    </th>
                                            {/* <th className='min-w-275px'>                                               
                                                {getValueFromResource('Employee Name',dispatch, t)}
                                                </th> */}
                                            <th style={{ width: '20%' }}>                                               
                                                {/* {getValueFromResource('Department Name',dispatch, t)} */}
                                                {getValueFromResource('Department Name',dispatch, t)}
                                                                        {pagination.sortColumn === '2' ?
                                                                            pagination.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                            </span>
                                                                            :
                                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                        <span className="path1"></span>
                                                                                        <span className="path2"></span>
                                                                                    </i>
                                                                                </span>
                                                                            </>}
                                                </th>
                                            <th className='min-w-125px'>
                                                {/* {getValueFromResource('Location',dispatch, t)} */}
                                                {getValueFromResource('Location',dispatch, t)}
                                                                        {pagination.sortColumn === '3' ?
                                                                            pagination.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                                            </span>
                                                                            :
                                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                                        <span className="path1"></span>
                                                                                        <span className="path2"></span>
                                                                                    </i>
                                                                                </span>
                                                                            </>}
                                                </th>
                                            {(allocationHoursInProjectTeam || allocationHoursInProjectTeam === 1) && <th className='min-w-125px'>
                                                {/* {t("Allocation Hours")} */}
                                                {getValueFromResource('Allocation Hours',dispatch, t)}
                                                </th>}
                                            <th className=''>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        checked={projectTeam.every((item: any) => item.isSelected === 0) ? false :
                                                            (projectTeam.every((item: any) => item.isSelected === 1 ? true : false))
                                                        }
                                                        onChange={handleSelectAllChange}
                                                    />
                                                </div>
                                            </th>
                                            {(accountIdsForAllocationHours || accountIdsForAllocationHours === 1) && 
                                            <th className='min-w-100px text-end'></th>
                                                }                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projectTeam.length > 0 && projectTeam.map((item: any) => {
                                            return (
                                                <tr key={item.AccountEmployeeId}>
                                                    <td>
                                                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                            <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                                                <div className='symbol-group symbol-hover flex-shrink-0 me-2' >
                                                                    <div className="symbol symbol-circle symbol-35px">
                                                                        <div className="symbol-label fw-bold text-inverse-warning" style={{ backgroundColor: item.ProfilePictureColor != '' ? item.ProfilePictureColor : '#512da8' }}>
                                                                            {item.FirstName.split('')[0].toUpperCase() + item.LastName.split('')[0].toUpperCase()}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <a className='text-dark fw-bold d-block'>
                                                            {item.FullName}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                            {item.DepartmentName}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <a className='text-gray-800 d-block'>
                                                            {item.AccountLocation}
                                                        </a>
                                                    </td>
                                                    {(allocationHoursInProjectTeam || allocationHoursInProjectTeam === 1) && <td>
                                                        <a className='text-gray-800 d-block'>
                                                            <input
                                                                type="text"
                                                                className="form-control inputFieldAlignment"
                                                                name="AllocationHours"
                                                                value={item.AllocationHours}
                                                                onChange={(e) => onHandleCalculation(e, item.AccountEmployeeId)}
                                                            />
                                                        </a>
                                                    </td>}
                                                    <td>
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                                            <input
                                                                className='form-check-input widget-9-check'
                                                                type='checkbox'
                                                                checked={item.isSelected == 0 ? false : true}
                                                                onChange={(e) => { onSelectTeamInProject(e, item.AccountEmployeeId) }}
                                                            />
                                                        </div>
                                                    </td>
                                                    
                                                    {(accountIdsForAllocationHours || accountIdsForAllocationHours === 1) && <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {"More"}
                                                        {getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="top"

                                                    >
                                                        <i className="bi bi-three-dots fs-7 " ></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu
                                                        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-2 w-150px'>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0 "
                                                                //onClick={() => { editAccountEmployeeById(item.AccountEmployeeId) }}
                                        onClick={() => {
                                            setSelectedProjectId(item.AccountProjectId);
                                            setSelectedEmployeeId(item.AccountEmployeeId);
                                            setSelectedProjectEmployeeId(item.AccountProjectEmployeeId);
                                            setSelectedProjectName(item.ProjectName);
                                            setSelectedDepartmentName(item.DepartmentName);
                                            setSelectedEmployeeName(item.FullName);
                                            dispatch(getDataByAllocationHours({ 
                                                accountProjectId: item.AccountProjectId, 
                                                accountEmployeeId: item.AccountEmployeeId, 
                                                accountProjectEmployeeId: item.AccountProjectEmployeeId
                                            }))
                                                .unwrap()
                                                .then((originalPromiseResult) => {

                                                    openModal();
                                                })
                                                .catch((rejectedValueOrSerializedError) => {
                                                    console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                                                })
                                        }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}

                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </>
                            }
                            {ProjectBillingRateTypeId === 3 &&
                                <>
                                    <thead>
                                        <tr className='thHeading align-middle'>
                                        <th style={{ width: '1%' }}>{t("")}</th>
                                            <th style={{ width: '11%' }}>
                                                {/* {t("Employee Name")} */}
                                                {getValueFromResource('Employee Name',dispatch, t)}
                                                </th>
                                            <th style={{ width: '5%' }}>
                                                {/* {t("Billing Currency")} */}
                                                {getValueFromResource('Billing Currency',dispatch, t)}
                                                </th>
                                            <th style={{ width: '5%' }}>
                                                {/* {t("Billing Rate")} */}
                                                {getValueFromResource('Billing Rate1',dispatch, t)}
                                                </th>
                                            <th style={{ width: '5%' }}>
                                                {/* {t("Employee Currency")} */}
                                                {getValueFromResource('Employee Currency',dispatch, t)}
                                                </th>
                                            <th style={{ width: '5%' }}>
                                                {/* {t("Employee Rate")} */}
                                                {getValueFromResource('Employee Rate',dispatch, t)}
                                                </th>
                                            <th style={{ width: '4%' }}>
                                                {/* {t("Start Date")} */}
                                                {getValueFromResource('Start Date',dispatch, t)}
                                                </th>
                                            <th style={{ width: '4%', }}>
                                                {/* {t("End Date")} */}
                                                {getValueFromResource('End Date',dispatch, t)}
                                                </th>
                                                <th style={{ width: '5%'}}>
                                                {/* {t("History")} */}
                                                {getValueFromResource('History',dispatch, t)}
                                                </th>
                                                <th style={{ width: '8%' }}>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        checked={projectTeam.every((item: any) => item.isSelected === 0) ? false :
                                                            (projectTeam.every((item: any) => item.isSelected === 1 ? true : false))
                                                        }
                                                        onChange={handleSelectAllChange}
                                                    />
                                                </div>
                                            </th>
                                            {(accountIdsForAllocationHours || accountIdsForAllocationHours === 1) &&
                                            <th className='min-w-100px text-end'></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projectTeam.length > 0 && projectTeam.map((item: any, index: number) => {
                                            return (
                                                <tr key={item.AccountEmployeeId}>
                                                    <td>
                                                        <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                            <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                                                <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                                                                    <div className="symbol symbol-circle symbol-35px" >
                                                                        <div className="symbol-label fw-bold text-inverse-warning" style={{ backgroundColor: item.ProfilePictureColor != '' ? item.ProfilePictureColor : '#512da8' }}>
                                                                            {item.FirstName.split('')[0].toUpperCase() + item.LastName.split('')[0].toUpperCase()}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <a className='text-dark fw-bold d-block'>
                                                            {item.FullName}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <Select
                                                            value={dropdownResponse.currenciesResponse.filter((x: any) => x.value === (item.BillingRateCurrencyId != null ? item.BillingRateCurrencyId : accountBaseCurrencyId))}
                                                            className="basic-single CurrencyWidth"
                                                            classNamePrefix="select"
                                                            name="billingCurrency"
                                                            onChange={(e, name) => onChange(e, name, item.AccountEmployeeId)}
                                                            options={dropdownResponse.currenciesResponse}
                                                            styles={{ ...colourStyles, ...CurrencyWidth }}
                                                            menuPlacement={index > 2 ? "top" : "bottom"}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPosition={'fixed'}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control inputFieldAlignment" style={{width:'80px'}}
                                                            name="BillingRate"
                                                            value={item.BillingRate != null ? item.BillingRate : 0}
                                                            //onChange={(e) => onHandleCalculation(e, item.AccountEmployeeId)}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            onHandleCalculation(e, item.AccountEmployeeId);
        }
        //onHandleCalculation(e, item.AccountEmployeeId);
    }}
    onBlur={(e) => {
            //let val = e.target.value.trim();
    // If empty or invalid, set to 0
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        e.target.value = formatted;
            onHandleCalculation(e, item.AccountEmployeeId);
    }
    
    }
                                                        />
                                                    </td>
                                                    <td>
                                                        <Select
                                                            value={dropdownResponse.currenciesResponse.filter((x: any) => x.value === (item.EmployeeRateCurrencyId != null ? item.EmployeeRateCurrencyId : accountBaseCurrencyId))}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            name="employeeRateCurrency"
                                                            onChange={(e, name) => onChange(e, name, item.AccountEmployeeId)}
                                                            options={dropdownResponse.currenciesResponse}
                                                            styles={{ ...colourStyles, ...CurrencyWidth }}
                                                            menuPlacement={index > 2 ? "top" : "bottom"}
                                                            maxMenuHeight={maxMenuHeight}
                                                            menuPosition={'fixed'}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control inputFieldAlignment"style={{width:'80px'}}
                                                            name="EmployeeRate"
                                                            value={item.EmployeeRate != null ? item.EmployeeRate : 0}
                                                            //onChange={(e) => onHandleCalculation(e, item.AccountEmployeeId)}
    onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            onHandleCalculation(e, item.AccountEmployeeId);
        }
        //onHandleCalculation(e, item.AccountEmployeeId);
    }}
    onBlur={(e) => {
            //let val = e.target.value.trim();
    // If empty or invalid, set to 0
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        e.target.value = formatted;
            onHandleCalculation(e, item.AccountEmployeeId);
    }
    
    }
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="wrapper">
                                                            <DatePicker
                                                                selected={new Date(item.StartDate)}
                                                                onChange={(date) => onDateChange(date, "StartDate", item.AccountEmployeeId)}
                                                                calendarStartDay={calendarStartDay}
                                                                className="form-control form-control-dark btn-icon-dark btn-text-dark inputFieldAlignment "
                                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                            >
                                                            </DatePicker>
                                                            <i className="insideField-Icons ki-outline ki-calendar text-gray me-10" ></i>
                                                        </div>
                                                        
                                                    </td>
                                                    <td>
                                                        <div className="wrapper">
                                                            <DatePicker
                                                                selected={new Date(item.EndDate)}
                                                                onChange={(date) => onDateChange(date, "EndDate", item.AccountEmployeeId)}
                                                                calendarStartDay={calendarStartDay}
                                                                className="form-control form-control-dark btn-icon-dark btn-text-dark inputFieldAlignment "
                                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                            >
                                                            </DatePicker>
                                                            <i className="insideField-Icons ki-outline ki-calendar text-gray me-10"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item.AccountBillingRateId != null &&
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary btn-sm custom-button-billing"
                                                                onClick={() => {
                                                                    navigate(`/accountbillingrate/${AccountProjectId}`, {
                                                                    // navigate('/accountbillingrate', {
                                                                        state: {
                                                                            "AccountProjectEmployeeId": item.AccountProjectEmployeeId,
                                                                            "SystemBillingRateTypeId": item.SystemBillingRateTypeId,
                                                                            "Id": AccountProjectId,
                                                                            "ProjectName": ProjectName,
                                                                            "AccountEmployeeId": item.AccountEmployeeId
                                                                        }
                                                                    })
                                                                }}
                                                            >
                                                                <i className="bi bi-pencil-square fs-5 me-1"></i>
                                                                {/* {t('History')} */}
                                                                {getValueFromResource('History',dispatch, t)}
                                                            </button>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox'>
                                                            <input
                                                                className='form-check-input widget-9-check'
                                                                type='checkbox'
                                                                checked={item.isSelected == 0 ? false : true}
                                                                onChange={(e) => { onSelectTeamInProject(e, item.AccountEmployeeId) }}
                                                            />
                                                        </div>
                                                    </td>
                                                    {(accountIdsForAllocationHours || accountIdsForAllocationHours === 1) && <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {"More"}
                                                        {getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="top"

                                                    >
                                                        <i className="bi bi-three-dots fs-7 " ></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu
                                                        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-2 w-150px'>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0 "
                                                                //onClick={() => { editAccountEmployeeById(item.AccountEmployeeId) }}
                                        onClick={() => {
                                            setSelectedProjectId(item.AccountProjectId);
                                            setSelectedEmployeeId(item.AccountEmployeeId);
                                            setSelectedProjectEmployeeId(item.AccountProjectEmployeeId);
                                            setSelectedProjectName(item.ProjectName);
                                            setSelectedDepartmentName(item.DepartmentName);
                                            setSelectedEmployeeName(item.FullName);
                                            dispatch(getDataByAllocationHours({ 
                                                accountProjectId: item.AccountProjectId, 
                                                accountEmployeeId: item.AccountEmployeeId, 
                                                accountProjectEmployeeId: item.AccountProjectEmployeeId
                                            }))
                                                .unwrap()
                                                .then((originalPromiseResult) => {

                                                    openModal();
                                                })
                                                .catch((rejectedValueOrSerializedError) => {
                                                    console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                                                })
                                        }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}

                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>}

                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </>
                            }
                            {ProjectBillingRateTypeId === 2 &&
                                <>
                                    <thead>
                                        <tr className='thHeading align-middle'>
                                            <th className='min-w-300px'>
                                                {/* {t("Role")} */}
                                                {getValueFromResource('Role',dispatch, t)}
                                                </th>
                                            <th className='min-w-300px'>
                                                {/* {t("Employee Name")} */}
                                                {getValueFromResource('Employee Name2',dispatch, t)}
                                                </th>
                                            {(allocationHoursInProjectTeam || allocationHoursInProjectTeam === 1) && <th className='min-w-275px'>
                                                {/* {t("Allocation Hours")} */}
                                                {getValueFromResource('Allocation Hours',dispatch, t)}
                                                </th>}
                                            <th className='min-w-50px'>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox justify-content-center'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        checked={projectTeam.every((item: any) => item.isSelected === 0) ? false :
                                                            (projectTeam.every((item: any) => item.isSelected === 1 ? true : false))
                                                        }
                                                        onChange={handleSelectAllChange}
                                                    />
                                                </div>
                                            </th>
                                            {(accountIdsForAllocationHours || accountIdsForAllocationHours === 1) &&
                                            <th className='min-w-100px text-end'></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projectTeam.length > 0 && projectTeam.map((item: any) => {
                                            return (
                                                <tr key={item.AccountProjectEmployeeId}>
                                                    <td>
                                                        <Select
                                                            value={dropdownResponse.accountRoleResponse.filter((x: any) => x.value === item.AccountRoleId)}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            options={dropdownResponse.accountRoleResponse}
                                                            styles={localColourStyles}
                                                            isDisabled={true}
                                                            maxMenuHeight={maxMenuHeight}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Select
                                                            value={dropdownResponse.accountEmployeeResponse.filter((x: any) => x.value === item.AccountEmployeeId)}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            name="accountEmployee"
                                                            onChange={(e, name) => onChange(e, name, item.AccountProjectEmployeeId)}
                                                            options={dropdownResponse.accountEmployeeResponse}
                                                            styles={localColourStyles}
                                                            isDisabled={item.AccountProjectEmployeeId > 0 ? true : false}
                                                            maxMenuHeight={maxMenuHeight}
                                                        />
                                                    </td>
                                                    {(allocationHoursInProjectTeam || allocationHoursInProjectTeam === 1) && <td>
                                                        <a className='text-gray-800 d-block'>
                                                            <input
                                                                type="text"
                                                                className="form-control inputFieldAlignment"
                                                                name="AllocationHours"
                                                                value={item.AllocationHours}
                                                                style={{ width: 350 }}
                                                                onChange={(e) => onHandleCalculation(e, item.AccountEmployeeId)}
                                                            />
                                                        </a>
                                                    </td>}
                                                    <td>
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid large-checkbox justify-content-center'>
                                                            <input
                                                                className='form-check-input widget-9-check'
                                                                type='checkbox'
                                                                checked={item.isSelected == 0 ? false : true}
                                                                onChange={(e) => { onSelectTeamInProject(e, item.AccountEmployeeId) }}
                                                            />
                                                        </div>
                                                    </td>
                                                    {(accountIdsForAllocationHours || accountIdsForAllocationHours === 1) && <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {"More"}
                                                        {getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="top"

                                                    >
                                                        <i className="bi bi-three-dots fs-7 " ></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu
                                                        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-2 w-150px'>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0 "
                                                                //onClick={() => { editAccountEmployeeById(item.AccountEmployeeId) }}
                                        onClick={() => {
                                            setSelectedProjectId(item.AccountProjectId);
                                            setSelectedEmployeeId(item.AccountEmployeeId);
                                            setSelectedProjectEmployeeId(item.AccountProjectEmployeeId);
                                            setSelectedProjectName(item.ProjectName);
                                            setSelectedDepartmentName(item.DepartmentName);
                                            setSelectedEmployeeName(item.EmployeeName);
                                            dispatch(getDataByAllocationHours({ 
                                                accountProjectId: item.AccountProjectId, 
                                                accountEmployeeId: item.AccountEmployeeId, 
                                                accountProjectEmployeeId: item.AccountProjectEmployeeId
                                            }))
                                                .unwrap()
                                                .then((originalPromiseResult) => {

                                                    openModal();
                                                })
                                                .catch((rejectedValueOrSerializedError) => {
                                                    console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                                                })
                                        }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}

                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>}
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </>
                            }
                        </table>
                        {projectTeam.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t("No Record Found")} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {isModalOpen &&
    <ProjectTeamAllocationHours modelRef={modelRef} t={t} oncloseModal={closeModal} accountprojectid={selectedProjectId} accountEmployeeId={selectedEmployeeId} accountProjectEmployeeId={selectedProjectEmployeeId} selectedProjectName={selectedProjectName} selectedDepartmentName={selectedDepartmentName} selectedEmployeeName={selectedEmployeeName} />
}
        </>
    )
}

export default ProjectTeam

const localColourStyles: StylesConfig = {
    control: (styles) => ({
        ...styles,
        backgroundColor: 'white',
        height: '100%',
        padding: '-1px',
        borderColor: '#EBECF0',
        marginRight: '0px',
        fontWeight: '400px',
        color: '#172B4F'
    })
}

const colourStyles: StylesConfig = {
    control: (styles) => ({
        ...styles,
        backgroundColor: 'white',
        width: 120,
        minHeight: '36px',
        height: '36px',
        padding: '-1px',
        borderColor: '#EBECF0',
        marginRight: '0px',
        fontWeight: '400px',
        color: '#172B4F'
    })
}
const CurrencyWidth: StylesConfig={
    control: (styles) =>({
        ...styles,
        width:'85px'
    })
}